<div class="flex flex-col gap-6 py-6">
  <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
    @for (card of cards(); track card.config.key) {
      <app-event-kpi-card
        [title]="'pages.admin.eventAnalytics.kpis.' + card.config.key + '.title' | translate"
        [infoMessage]="'pages.admin.eventAnalytics.kpis.' + card.config.key + '.info' | translate"
        [valueType]="card.config.valueType"
        [currentValue]="card.currentValue"
        [totalValue]="card.totalValue"
        [comparedCurrentValue]="card.comparedCurrentValue"
        [enableProgressBar]="!!card.config.enableProgressBar"
        [comparing]="store.isComparing$()"
        [loading]="store.kpisLoading$()"
      />
    }
  </div>

  <app-admin-event-analytics-overview-bar-graphs [kpis]="store.kpis$()" [loading]="store.kpisLoading$()" />
</div>
